import { render, staticRenderFns } from "./case_studies.vue?vue&type=template&id=292e4039&"
import script from "./case_studies.vue?vue&type=script&lang=js&"
export * from "./case_studies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/proservdemo25/public_html/wp-content/themes/chop-child/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('292e4039')) {
      api.createRecord('292e4039', component.options)
    } else {
      api.reload('292e4039', component.options)
    }
    module.hot.accept("./case_studies.vue?vue&type=template&id=292e4039&", function () {
      api.rerender('292e4039', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/case_studies.vue"
export default component.exports